
import { Component, Vue } from 'vue-property-decorator';

import Form17ProcessHeader from "@/components/process/Form17/components/Form17ProcessHeader.vue";
import Form17StyleOfProceeding from "@/components/process/Form17/components/Form17StyleOfProceeding.vue";
import { form17StatusInfoType } from '@/types/Information/Form17';

@Component({
    components:{
        Form17ProcessHeader,        
        Form17StyleOfProceeding
    }
})
export default class FillForm17 extends Vue {

    stepsCompleted = {} as form17StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
